import React, {useState} from "react";
import {authApi} from "../../api";
import {Link, useNavigate} from "react-router-dom";
import {useAuth} from "../../context/AuthContext";

export default function Register() {
    const navigate = useNavigate();
    const {login} = useAuth();

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [agreed, setAgreed] = useState(false);
    const [showValidation, setShowValidation] = useState(false);

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setSuccess(false);

        if (!agreed) {
            setShowValidation(true);
            return;
        }

        try {
            const res = await authApi.register(formData);

            const {user, accessToken, refreshToken, cartGuid} = res.data;

            login(user, accessToken, refreshToken, cartGuid);

            const fromCheckout = sessionStorage.getItem("fromCheckout");
            // ❌ BUNU SİL → localStorage.removeItem("cart_guid");
            // if (cartGuid) {
            //     localStorage.setItem("cart_guid", cartGuid);
            // }


            setSuccess(true);

            // 🔒 Popup kapat
            const offcanvasEl = document.getElementById("register");
            if (offcanvasEl && window.bootstrap?.Offcanvas) {
                const instance = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
                instance?.hide();
            }

            if (fromCheckout) {
                sessionStorage.removeItem("fromCheckout");
                setTimeout(() => {
                    navigate("/checkout", {replace: true});
                }, 300);
                return;
            }

            // 🔁 Yönlendir
            // setTimeout(() => {
            //     navigate("/");
            // }, 300);
            navigate("/", {replace: true});

        } catch (err) {
            setError(err.response?.data?.message || "Registration failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="offcanvas offcanvas-end popup-style-1 popup-register input-page"
            id="register"
        >
            <div className="canvas-wrapper">
                <div className="canvas-header popup-header">
                    <span className="title">Create account</span>
                    <button
                        className="icon-close icon-close-popup"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        data-bs-focus="false"
                    />
                </div>
                <div className="canvas-body popup-inner">
                    <form onSubmit={handleSubmit} className="form-login">
                        <fieldset className="text mb_12">
                            <input
                                type="text"
                                name="firstName"
                                placeholder="First name"
                                value={formData.firstName}
                                onChange={handleChange}
                                required
                            />
                        </fieldset>
                        <fieldset className="text mb_12">
                            <input
                                type="text"
                                name="lastName"
                                placeholder="Last name"
                                value={formData.lastName}
                                onChange={handleChange}
                                required
                            />
                        </fieldset>
                        <fieldset className="email mb_12">
                            <input
                                type="email"
                                name="email"
                                placeholder="Email*"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </fieldset>
                        <fieldset className="password">
                            <input
                                type="password"
                                name="password"
                                placeholder="Password*"
                                value={formData.password}
                                onChange={handleChange}
                                required
                            />
                        </fieldset>


                        <div className="check-agree mt-3">
                            <input
                                type="checkbox"
                                className="tf-check"
                                id="check-agree"
                                checked={agreed}
                                onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    setAgreed(isChecked);
                                    if (isChecked) {
                                        setShowValidation(false);
                                    }
                                }}
                            />
                            <label className="form-check-label text-dark " htmlFor="check-agree">
                                &nbsp;&nbsp;I agree with{" "}
                                <Link
                                    to={`/terms-and-conditions`}
                                    className="text-dark fw-medium text-decoration-underline"
                                >
                                    terms and conditions
                                </Link>
                            </label>

                            {showValidation && !agreed && (
                                <div className="text-danger mt-2 small">
                                    Please accept the terms and conditions to continue!
                                </div>
                            )}
                        </div>


                        {error && <div className="text-danger mt-2">{error}</div>}
                        {success && <div className="text-success mt-2">Registration successful!</div>}

                        <div className="button-wrap mt-3">
                            <button
                                className="subscribe-button tf-btn animate-btn bg-dark-2 w-100"
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? "Signing up..." : "Sign up"}
                            </button>

                            <button
                                type="button"
                                data-bs-target="#login"
                                data-bs-toggle="offcanvas"
                                className="tf-btn btn-out-line-dark2 w-100"
                            >
                                Sign in
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
